import { forwardRef, type Ref, type SVGProps } from "react";

function SvgQuizSuccess(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={176}
      height={120}
      fill="none"
      {...props}
    >
      <rect
        width={76}
        height={94}
        x={50}
        y={13}
        stroke="url(#quiz_success_svg__a)"
        strokeWidth={10}
        rx={13.333}
      />
      <path stroke="#0D2B57" strokeLinecap="round" d="M67.5 34.5h41m-41 10h41" />
      <path
        fill="#0D2B57"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m121.091 52.033-.52.52a6.94 6.94 0 0 1-4.909 2.034h-.133a6.94 6.94 0 0 0-6.942 6.942v.133a6.94 6.94 0 0 1-2.033 4.909l-.521.52a6.94 6.94 0 0 0 0 9.818l.521.52a6.94 6.94 0 0 1 2.033 4.91v.132a6.94 6.94 0 0 0 6.942 6.942h.133c1.841 0 3.607.731 4.909 2.033l.52.52a6.94 6.94 0 0 0 9.818 0l.52-.52a6.94 6.94 0 0 1 4.909-2.033h.133a6.94 6.94 0 0 0 6.942-6.942v-.133c0-1.841.731-3.607 2.033-4.909l.521-.52a6.94 6.94 0 0 0 0-9.818l-.521-.52a6.94 6.94 0 0 1-2.033-4.91v-.132a6.94 6.94 0 0 0-6.942-6.942h-.133a6.94 6.94 0 0 1-4.909-2.033l-.52-.52a6.94 6.94 0 0 0-9.818 0"
      />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m120.167 73.25 3.5 3.75 8.166-10"
      />
      <defs>
        <linearGradient
          id="quiz_success_svg__a"
          x1={88}
          x2={88}
          y1={13}
          y2={107}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ADF3C7" />
          <stop offset={1} stopColor="#F6F3F1" />
        </linearGradient>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgQuizSuccess);
export default ForwardRef;
